
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import DetailTable from 'Modules/dashboard/views/.components/dashboardPanel/.components/detailTable';
//Actions
import {
    vidfleetClipRequestDetailsRequest,
    clearRedux,
} from 'Redux/actions';

//Styles
import './index.scss';

const VidFleetClipRequestsDetails = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const {
        openModal,
        loading,
        result,
        data
    } = useSelector(state => state.vidFleetClipRequestsDetailsRedux);

    //Local States
    const [columns, setColumns] = useState([]);

    const closeModal = () => {
        dispatch(clearRedux("VIDFLEET_CLIP_REQUESTS_DETAILS"))
        setColumns([])
    }

    useEffect(() => {
        if (openModal && data?.status) {
            let payload = {
                id: data?.gadgetId,
                query: {
                    level: 1,
                    gadgetParams: JSON.stringify({ status: data?.status })
                }
            }
            dispatch(vidfleetClipRequestDetailsRequest(payload))
        }
        return () => {
            dispatch(clearRedux("VIDFLEET_CLIP_REQUESTS_DETAILS"))
        }
    }, [openModal])

    return (
        <div className='create-edit-modal'>
            <Modal
                open={openModal}
                title={`${messages['vidfleetClips_status']} (${data?.status})`}
                handleClose={() => closeModal()}
                position="right"
                loading={loading || columns?.length === 0}
                size="medium"
            >
                <ModalBody>
                    {result && <DetailTable result={result} onChangeColumns={setColumns} />}
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default VidFleetClipRequestsDetails;